import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { MemberEvaluationDataSource } from '../../models/memberEvaluationDataSource';

@Component({
  selector: 'app-evaluation-respond-item',
  templateUrl: './evaluation-respond-item.component.html',
  styleUrls: ['./evaluation-respond-item.component.scss'],
  standalone: false
})
export class EvaluationRespondItemComponent implements OnInit {
  @Input() source: MemberEvaluationDataSource;
  @Input() isPrivate: boolean = false;
  @Output() downloadFile: EventEmitter<{ fileName: string; attributeDefinitionId: string }> =
    new EventEmitter<{ fileName: string; attributeDefinitionId: string }>();

  constructor() {}

  ngOnInit(): void {}

  onDownloadFile(event: { fileName: string; attributeDefinitionId: string }) {
    this.downloadFile.emit(event);
  }
}
